import React, { lazy } from 'react';
import { withErrorBoundary } from '@guildeducationinc/mfe-utils';
import { logDataDogError } from '@src/utilities/datadog';

const FeedbackWidgetRemote = lazy(
	async () =>
		await import(/* webpackChunkName: "remote/FeedbackWidget" */ 'FeedbackWidget/FeedbackWidget')
);

export const FeedbackWidget = withErrorBoundary({
	component: FeedbackWidgetRemote,
	fallback: (error, componentStack) => {
		logDataDogError(error, 'FeedbackWidgetRemoteError', { componentStack });
		return <></>;
	},
});
